import { Component, OnInit, OnDestroy } from '@angular/core';
import {SideNavToggle} from '../../interfaces/generalInterfaces'
import { BaseServiceService } from 'src/app/services/base-service.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrl: './layout.component.css'
})
export class LayoutComponent implements OnInit, OnDestroy {


  isSideNavCollapsed = false;
  screenWidth = 0;
  isRedirectAccess: boolean = false;
  private redirectAccessSubscription?: Subscription;
  
  constructor(private baseService: BaseServiceService) {}
  
  ngOnInit(): void {
    this.redirectAccessSubscription = this.baseService.isRedirectAccess$.subscribe(
      (isRedirect: boolean) => this.isRedirectAccess = isRedirect
    );
  }

  ngOnDestroy(): void {
    if (this.redirectAccessSubscription) {
      this.redirectAccessSubscription.unsubscribe();
    }
  }
  
  onToogleSideNav(data: SideNavToggle): void{
    this.screenWidth = data.screenWidth;
    this.isSideNavCollapsed = data.collapsed;
    
  }
}
